import z from "zod";

// eslint-disable-next-line import/prefer-default-export
export const SEOSchema = z.object({
    metaDescription: z.string().nullable().optional(),
    metaTitle: z.string().nullable().optional(),
    keywords: z.string().nullable().optional(),
    synonyms: z.string().nullable().optional()
});
